export const colors = {
  text: {
    primary: "#1B252F",
    secondary: "#6B7A94",
    action: "#3A8AB9",
    link: "#0E426D",
    error: "#A40101",
    white: "#FFFFFF",
  },
  background: {
    default: "#F5F9FD",
    secondary: "#FFFFFF",
    red: "#FFF5F4",
    lightBlue: "#E3F2FD",
    pagination: "#FAFBFD",
    darkBlue: "#0E426D",
    mediumBlue: "#E8F6F9",
  },
  primary: {
    main: "#3A8AB9",
    light: "#5BA3D1",
    dark: "#2D6B8F",
  },
  secondary: {
    main: "#6B7A94",
    light: "#8A9BB0",
    dark: "#4A5A6F",
  },
  status: {
    success: "#4CAF50",
    error: "#EF5350",
    info: "#2196F3",
    invited: "#F4B400",
    suspended: "#EF5350",
    active: "#4CAF50",
    activeText: "#296C50",
    activeBg: "#E6F4EE",
    invitedText: "#BE8522",
    invitedBg: "#FFFBE6",
    suspendedText: "#A40101",
    suspendedBg: "#FFF5F4",
  },
  amber: {
    main: "#F4B400",
    light: "#FFD054",
    dark: "#C58F00",
    background: "#FFFBEB",
    text: "#92600A",
  },
  border: {
    light: "#E0E0E0",
    medium: "#B9CED5",
    dark: "#757575",
    pagination: "#E2E8F0",
  },
  shadow: {
    modal: "0 14px 24px 0 rgba(168, 182, 215, 0.15)",
  },
} as const;
export const { text, background, primary, secondary, status, border, shadow } =
  colors;
